
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import translationEN from './locales/en/translationEN.json';
import translationAR from './locales/ar/translationAR.json';
import translationFR from './locales/fr/translationFR.json';


i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      ar: {
        translation: translationAR,
      },
      fr: {
        translation: translationFR,
      },
    },
    lng: 'fr', // default language
    fallbackLng: 'en', // fallback language
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;
